<template>
	<div id="misDatos">

		<b-card header="Métodos de pago">
			<metodos-pago-stripe />
		</b-card>
		
		<b-form class="mt-3" @submit.prevent="onSubmit()">
			<b-card header="Datos de personales">

				<form-signup :title="null" v-model="form"/>

				<div class="text-right mt-2">
					<b-button type="submit" class="btn-red btn-form" variant="primary" :disabled="disabled">
						Guardar cambios
					</b-button>
				</div>

			</b-card>
		</b-form>

		<sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modal">
			<div class="fa-3x" v-if="modal.icon == ''"><i class="fas fa-spinner fa-pulse"></i></div><br />
			{{ modal.msg }}
			<div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
				<b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close();">OK</b-button>
			</div>
		</sweet-modal>
	</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import formSignup from '../daniel/form-signup.vue'
import metodosPagoStripe from './metodos-pago-stripe.vue'

export default {
	// COMPONENTS
	components: { 
		formSignup, 
		metodosPagoStripe
	},

	// DATA
	data() {
		return {
			states: [],
			towns: [],
			disabled: false,
			form: null,

			modal: {
				msg: '',
				icon: '',
				block: false,
			},
		}
	},

	// COMPUTED
	computed: {
		...mapGetters(['getUser'])
	},

	// MOUNTED
	mounted(){
		this.form = _.clone(this.getUser)
	}
}
</script>

<style lang="less">
#misDatos {}
</style>